import PropTypes from 'prop-types'

export const SlideScribble = ({
  className = '',
  fillColor = 'currentColor',
}) => (
  <svg
    className={className}
    width="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -5 12 170"
    preserveAspectRatio="none"
  >
    <path
      d="M8.11992 121.149C8.33192 115.846 9.00326 99.2298 8.93259 98.2305C8.89726 97.3441 8.43792 91.7516 8.11992 87.3678L8.11992 67.0445C8.22592 67.1412 8.33192 67.2217 8.33192 67.3185C8.61459 69.3331 8.9326 71.3638 9.07393 73.3945C9.21527 75.2157 9.0386 77.0369 9.1446 78.842C9.1446 78.9226 10.0986 91.0908 10.1339 91.1714C12.2186 97.054 9.8866 103.211 9.7806 108.755C9.70993 112.397 9.92193 116.04 10.0279 119.666C10.0633 120.23 10.4873 121.31 10.4166 122.325C10.1693 124.936 9.7806 125.629 9.53326 126.709C9.49793 126.886 9.4626 127.16 9.63926 127.241C11.0173 127.966 10.2753 128.917 10.3106 129.771C10.4166 134.735 10.1693 133.285 10.7346 134.381C10.8406 134.139 11.0173 133.881 11.0173 133.639C11.9006 117.329 11.3706 121.729 11.4413 111.962C11.512 102.163 13.6673 94.0885 10.4873 74.7967C9.63927 69.6232 9.28593 64.4497 9.10927 59.26C9.0386 57.0681 8.7206 54.8763 8.54393 52.6844C8.40259 50.976 8.26126 49.2676 8.15526 47.5592C8.15526 47.4464 8.15526 47.3336 8.15526 47.2369V42.9659C8.29659 39.6458 8.57926 36.3258 8.26126 32.9735C8.22592 32.635 8.19059 32.2966 8.15526 31.9581L8.15526 15.9541C8.68526 11.9732 8.75593 7.96014 9.07394 3.96317C9.10927 3.57636 9.2506 3.86647 8.47326 2.70605C8.36726 2.81887 8.26126 2.91557 8.15526 3.01227V0.498047L-0.718735 0.498047L-0.71875 168H8.11991L8.11992 121.149ZM8.11992 61.468V60.6622C8.15526 61.0007 8.15526 61.2585 8.11992 61.468Z"
      fill={fillColor}
    />
  </svg>
)

SlideScribble.propTypes = {
  className: PropTypes.string,
  fillColor: PropTypes.string,
}

export default SlideScribble
